module.exports = __webpack_public_path__ + "static/img/NF.8b3e0ad9.svg";